import { OrderStatus } from "@goodfill/domain-properties/src";
import React from "react";

export const OrderStatusComponent = (props: { value: OrderStatus }) => {
  switch (props.value) {
    case OrderStatus.CanceledByCustomer:
      return <>Canceled</>;

    case OrderStatus.CanceledByTrader:
      return <>Canceled</>;

    case OrderStatus.FillSubmittedToBroker:
      return <>Open</>;

    case OrderStatus.CancelSubmittedToBroker:
      return <>Pending Status Change</>;

    case OrderStatus.PendingCancelApproval:
      return <>Pending Status Change</>;

    // case OrderStatus.Expired:
    //   return <>Expired</>

    case OrderStatus.Closed: // FullyFilled
      return <>Filled</>;

    default:
      return <>{props.value}</>;
  }
};
